import React from 'react';
import { Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';

/*
 * Render inside a <Tab.Container>. react-bootstrap gives inactive tabs
 * tabIndex="-1" (roving focus) but only wires up arrow-key navigation when a
 * tab context is present, so without the container the tabs are unreachable.
 */
const CommunityTabs = ({ activeTab, onTabChange }) => {
    const tabs = [
        { key: 'posts', label: 'Posts' },
        { key: 'members', label: 'Members' },
        { key: 'events', label: 'Events' },
        { key: 'similar', label: 'Similar' },
        { key: 'guidelines', label: 'Guidelines' },
    ];

    return (
        <Nav
            variant="tabs"
            activeKey={activeTab}
            onSelect={onTabChange}
            className="community-tabs border-bottom mb-4"
            role="tablist"
            aria-label="Community sections"
        >
            {tabs.map((tab) => (
                <Nav.Item key={tab.key} role="presentation">
                    {/* aria-selected, id and aria-controls come from useNavItem */}
                    <Nav.Link
                        eventKey={tab.key}
                        className="community-tab-link"
                        role="tab"
                    >
                        {tab.label}
                    </Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
};

CommunityTabs.propTypes = {
    activeTab: PropTypes.string.isRequired,
    onTabChange: PropTypes.func.isRequired,
};

export default CommunityTabs;
